import {
  UPDATE_LINK_TYPE_VALUE,
  UPDATE_CONNECTOR_LOCATION_VALUE,
  UPDATE_CONNECTOR_SOURCE_VALUE,
  UPDATE_CONNECTOR_TYPE_VALUE,
  UPDATE_CONNECTOR_FEATURE_VALUE,
  ADD_DISPLAY_CONNECTOR,
  REMOVE_DISPLAY_CONNECTOR,
} from './constants'

export const updateLinkTypeValue = (index, linkType) => {
  return {
    type: UPDATE_LINK_TYPE_VALUE,
    linkType,
    index
  }
}

export const updateConnectorLocationValue = (index, connectorLocation) => {
  return {
    type: UPDATE_CONNECTOR_LOCATION_VALUE,
    connectorLocation,
    index
  }
}

export const updateConnectorSourceValue = (index, connectorSource) => {
  return {
    type: UPDATE_CONNECTOR_SOURCE_VALUE,
    connectorSource,
    index
  }
}

export const updateConnectorFeatureValue = (index, connectorFeature) => {
  return {
    type: UPDATE_CONNECTOR_FEATURE_VALUE,
    connectorFeature,
    index
  }
}

export const updateConnectorTypeValue = (index, connectorType) => {
  return {
    type: UPDATE_CONNECTOR_TYPE_VALUE,
    connectorType,
    index
  }
}

export const addDisplayConnector = () => {
  return {
    type: ADD_DISPLAY_CONNECTOR
  }
}

export const removeDisplayConnector = (index) => {
  return {
    type: REMOVE_DISPLAY_CONNECTOR,
    index
  }
}
